import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import { ETFService } from '../../../../shared/services/etf.service';
import {
  CIndexDescription, GetIndexNoFinalTrialReq, GetIndexNoFinalTrialRes, IndexMarketData
} from '../../../../shared/models/etf';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
@Component({
  selector: 'app-etf-indices',
  templateUrl: './etf-indices.component.html',
  styleUrls: ['./etf-indices.component.scss']
})
export class EtfIndicesComponent {
  @Input() FundShortName: string= '';
  @Input() FundWarning: string= '';
  @Input() data: Array<CIndexDescription> = [];
  @Input() navData: IndexMarketData = {} as IndexMarketData;
  @Input() FundNo:string='';

  getIndexNoFinalTrialReq: GetIndexNoFinalTrialReq = {} as GetIndexNoFinalTrialReq;
  getIndexNoFinalTrialRes: GetIndexNoFinalTrialRes = {} as GetIndexNoFinalTrialRes;
  displayCount = 10;

  constructor(
    public baseService: BaseService,
    public ETFService: ETFService,
  ) {
  }
  ngOnInit(): void {
    if (this.FundNo) {
      this.GetIndexNoFinalTrial();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
      this.data = this.data.map(item => {
        return {
          ...item,
          Val: item.Val.replace(/\r\n|\n/g, '<br>')
        };
      });

        // 當 FundNo 變更時重新呼叫 API
        if (changes['FundNo'] && changes['FundNo'].currentValue &&
            changes['FundNo'].currentValue !== changes['FundNo'].previousValue) {
          this.GetIndexNoFinalTrial();
        }
  }

  GetIndexNoFinalTrial() {
    if (!this.FundNo) {
      console.warn('FundNo 為空，無法呼叫 GetIndexNoFinalTrial API');
      return;
    }

    this.getIndexNoFinalTrialReq.CFundNo = this.FundNo;
    this.ETFService.GetIndexNoFinalTrial(this.getIndexNoFinalTrialReq).subscribe((res) => {
      this.getIndexNoFinalTrialRes = res.Entries;
    });
  }

  showMore() {
    this.displayCount += 10;
  }
}
